import "./ExcelDocUploader.scss";

import {
  CButton,
  CCol,
  CInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import React, { useRef, useState } from "react";
import {
  defaultDivision,
  getDivisionPrimaryButtonClass,
} from "../../../utils/formatUtils";

import { toast } from "react-toastify";

export default function ExcelDocUploader({
  setShowModal,
  handleImport,
  queryParam,
  forceUpdate,
  setLoadingParent,
  handleCleanup,
  showPrompt,
  promptMessage,
}: {
  setShowModal: (show: boolean) => void;
  forceUpdate: () => void;
  handleImport: (formData: FormData, activeDate: Date) => Promise<void>;
  queryParam: Date;
  setLoadingParent?: (loading: boolean) => void;
  handleCleanup: () => void;
  showPrompt: boolean;
  promptMessage: string;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [excelDocToSave, setExcelDocToSave] = useState<File>();
  const [showAreYouSureModal, setShowAreYouSureModal] = useState(false);
  const [uploadDisabled, setUploadDisabled] = useState(false);

  const handleExcelDocChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const excelDocFile = e.target.files[0];
      if (
        excelDocFile.type.split("/")[1] ===
          "vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        excelDocFile.type.split("/")[1] === "vnd.ms-excel"
      ) {
        const reader = new FileReader();

        reader.addEventListener(
          "load",
          function () {
            setExcelDocToSave(excelDocFile);
          },
          false,
        );

        reader.readAsDataURL(excelDocFile);
      } else {
        toast.error("File must be an excel document.");
        setExcelDocToSave(undefined);
        if (inputRef.current) {
          inputRef.current.value = "";
        }
      }
    } else {
      setExcelDocToSave(undefined);
      if (inputRef.current) {
        inputRef.current.value = "";
      }
    }
  };

  const handleSaveExcelDoc = async () => {
    setUploadDisabled(true);
    try {
      if (excelDocToSave) {
        const formData = new FormData();
        formData.append("file", excelDocToSave);

        if (setLoadingParent) {
          setLoadingParent(true);
        }
        await handleImport(formData, queryParam).catch((error: any) => {
          console.log(error);
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      if (setLoadingParent) {
        setLoadingParent(false);
      }
      if (forceUpdate) {
        forceUpdate();
      }

      if (handleCleanup) {
        handleCleanup();
      }
    }

    setExcelDocToSave(undefined);
    // Reset input for older browser support
    if (inputRef.current) {
      inputRef.current.type = "text";
      inputRef.current.type = "file";

      // Set value to empty string for filepath for modern browsers
      inputRef.current.value = "";
    }

    setShowModal(false);
    setShowAreYouSureModal(false);
    setUploadDisabled(false);
  };

  return (
    <>
      <CRow className="w-100">
        <CCol className="pr-0">
          <CInput
            innerRef={inputRef}
            className="h-100 m-0 p-0"
            type="file"
            id="excel-doc-uploader"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onChange={handleExcelDocChange}
          ></CInput>
        </CCol>

        <CButton
          id="uploadButton"
          disabled={uploadDisabled}
          type="button"
          onClick={
            showPrompt
              ? () => setShowAreYouSureModal(true)
              : () => handleSaveExcelDoc()
          }
          className={`${getDivisionPrimaryButtonClass(
            defaultDivision,
          )} ml-3 mr-0`}
        >
          Upload
        </CButton>
      </CRow>
      <CModal
        show={showAreYouSureModal}
        closeOnBackdrop={false}
        onClose={() => {
          setShowAreYouSureModal(false);
        }}
        centered={true}
      >
        <CModalHeader closeButton>
          <CModalTitle>Are you sure?</CModalTitle>
        </CModalHeader>
        <CModalBody>{promptMessage}</CModalBody>
        <CModalFooter>
          <CButton
            className={getDivisionPrimaryButtonClass(defaultDivision)}
            onClick={() => setShowAreYouSureModal(false)}
          >
            No
          </CButton>
          <CButton
            className={getDivisionPrimaryButtonClass(defaultDivision)}
            onClick={handleSaveExcelDoc}
          >
            Yes
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  );
}
